import { useState } from "react";
import { useTitle } from "@/lib/router";
import { Card, EntityPicker, Field, PageHeader, type EntityRef } from "@/ui/kit";
import { DocumentsPanel } from "./shared";

/**
 * Documentos ficam sempre dentro de um contexto (pessoa, caso ou processo).
 * Aqui é um atalho: escolha o contexto e trabalhe nos arquivos dele.
 */
export function DocumentsPage(): JSX.Element {
  useTitle("Documentos");
  const [ctx, setCtx] = useState<EntityRef | null>(null);
  const key = ctx ? (ctx.kind === "pessoa" ? { personId: ctx.id } : ctx.kind === "caso" ? { caseId: ctx.id } : { processId: ctx.id }) : null;
  return (
    <div className="stack gap-16">
      <PageHeader title="Documentos" subtitle="Arquivos do sistema, com versão e trilha de acesso. O SharePoint segue como repositório principal." />
      <Card>
        <Field label="Contexto"><EntityPicker kinds={["processo", "caso", "pessoa"]} value={ctx} onChange={setCtx} placeholder="Busque o processo, caso ou pessoa…" /></Field>
      </Card>
      {key && <DocumentsPanel ctx={key} title={`Documentos — ${ctx!.label}`} />}
    </div>
  );
}
